import { PlatformIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_PLATFORM: AppConfig = {
  name: 'Solutions Platform',
  applicationKey: 'platform',
  type: 'external-app',
  Icon: PlatformIcon,
  appSlugForEngagement: AppSlugs.Platform,
  globalHeaderTitle: '',
  rootPath: `/platform`,
  descriptionLong:
    'Functionality that spans many HouseCanary Solutions products.',
  descriptionShort:
    'Functionality that spans many HouseCanary Solutions products.',
};

export type ReportHistoryOption = 'active' | 'expired' | 'all';

// Platform Search URL params
export const PlatformPageModalParam = 'platformModal';
export const PlatformPagePersonasVal = 'personas';
// This controls whether the property pane is open in the Platform Search page on desktop (shows to the right of the map)
// and mobile (takes the full screen, overlaying the map)
export const ActivePropertyParam = 'activePropertySlug';
// This controls whether the property card is shown over the map on mobile
export const ActiveMobileMapPropertyParam = 'activeMobileMapPropertySlug';
export const MapLayerParam = 'mapLayer';
export const ContentPaneViewParam = 'contentView';
export const ReportHistoryTypeParam = 'reportHistoryType';
export const ZipcodesParam = 'zipcodes';
export const MsaParam = 'msaId';
export const MarketInsightsOption = 'Market Insights';
export const SearchResultsOption = 'Property Search';
